module.exports = __webpack_public_path__ + "static/fonts/33f5d8d9-105f-4a49-9351-74ecae7f4a49.32044ed.ttf";